/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './Pageable';
import type { Sort } from './Sort';
import {
    SortFromJSON,
    SortFromJSONTyped,
    SortToJSON,
} from './Sort';
import type { StatusReportDTO } from './StatusReportDTO';
import {
    StatusReportDTOFromJSON,
    StatusReportDTOFromJSONTyped,
    StatusReportDTOToJSON,
} from './StatusReportDTO';

/**
 * 
 * @export
 * @interface StatusReportPageDTO
 */
export interface StatusReportPageDTO {
    /**
     * 
     * @type {Array<StatusReportDTO>}
     * @memberof StatusReportPageDTO
     */
    content?: Array<StatusReportDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof StatusReportPageDTO
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StatusReportPageDTO
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof StatusReportPageDTO
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof StatusReportPageDTO
     */
    numberOfElements?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof StatusReportPageDTO
     */
    pageable?: Pageable;
    /**
     * 
     * @type {number}
     * @memberof StatusReportPageDTO
     */
    size?: number;
    /**
     * 
     * @type {Sort}
     * @memberof StatusReportPageDTO
     */
    sort?: Sort;
    /**
     * 
     * @type {number}
     * @memberof StatusReportPageDTO
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof StatusReportPageDTO
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the StatusReportPageDTO interface.
 */
export function instanceOfStatusReportPageDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StatusReportPageDTOFromJSON(json: any): StatusReportPageDTO {
    return StatusReportPageDTOFromJSONTyped(json, false);
}

export function StatusReportPageDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatusReportPageDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': !exists(json, 'content') ? undefined : ((json['content'] as Array<any>).map(StatusReportDTOFromJSON)),
        'first': !exists(json, 'first') ? undefined : json['first'],
        'last': !exists(json, 'last') ? undefined : json['last'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'pageable': !exists(json, 'pageable') ? undefined : PageableFromJSON(json['pageable']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'sort': !exists(json, 'sort') ? undefined : SortFromJSON(json['sort']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
    };
}

export function StatusReportPageDTOToJSON(value?: StatusReportPageDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content === undefined ? undefined : ((value.content as Array<any>).map(StatusReportDTOToJSON)),
        'first': value.first,
        'last': value.last,
        'number': value.number,
        'numberOfElements': value.numberOfElements,
        'pageable': PageableToJSON(value.pageable),
        'size': value.size,
        'sort': SortToJSON(value.sort),
        'totalElements': value.totalElements,
        'totalPages': value.totalPages,
    };
}

